"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alreadyHave;

var _noty = require("noty");

function alreadyHave(data) {
  (0, _noty.showNotificationText)("You have been signed in. It appears that you already have access to the ".concat(data.type.toLowerCase(), " \"").concat(data.title, "\"."));
}